import { render, staticRenderFns } from "./NotasFiscaisLista.vue?vue&type=template&id=de50a948&scoped=true&"
import script from "./NotasFiscaisLista.vue?vue&type=script&lang=js&"
export * from "./NotasFiscaisLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de50a948",
  null
  
)

export default component.exports